export default "__VITE_ASSET__BLltqGRf__"